var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Catch, InternalError, KycDaoSDKError } from '../../errors';
import { ipfsToHttps } from '../../utils';
import { Provider } from 'aptos';
import { NetworkMapping } from './aptos-provider-wrapper';
export class AptosJsonRpcProvider {
    constructor(contractAddress, network) {
        this.contractAddress = contractAddress;
        this.provider = new Provider(NetworkMapping[network]);
    }
    async getTransaction(txHash) {
        try {
            if (await this.provider.transactionPending(txHash)) {
                return {
                    status: 'Started',
                };
            }
            const tx = (await this.provider.getTransactionByHash(txHash));
            if (tx.success) {
                const event = tx.events.find((event) => event.type === '0x4::collection::MintEvent');
                return {
                    status: 'Success',
                    data: event ? event.data.token : null,
                };
            }
            else {
                return {
                    status: 'Failure',
                };
            }
        }
        catch (e) {
            throw new InternalError(`Transaction ${txHash} doesn't exist`);
        }
    }
    async hasValidNft(targetAddress) {
        const resp = await this.provider.view({
            function: this.contractAddress + '::kycdao_sbt::has_valid_token',
            type_arguments: [],
            arguments: [targetAddress],
        });
        return resp[0];
    }
    async tokenAddrForOwner(targetAddress) {
        const resp = await this.provider.view({
            function: this.contractAddress + '::kycdao_sbt::get_token_addr_from_acct',
            type_arguments: [],
            arguments: [targetAddress],
        });
        return resp[0];
    }
    async getTokenData(tokenAddr) {
        const tokenDataResp = await this.provider.getTokenData(tokenAddr, { tokenStandard: 'v2' });
        const tokenData = tokenDataResp.current_token_datas_v2[0];
        const resp = await fetch(tokenData.token_uri);
        const metadata = await resp.json();
        return {
            name: metadata.name,
            description: metadata.description,
            image: ipfsToHttps(metadata.image),
        };
    }
    async getValidNftsCore(targetAddress) {
        const hasValidNft = await this.hasValidNft(targetAddress.address);
        if (hasValidNft) {
            const tokenAddr = await this.tokenAddrForOwner(targetAddress.address);
            const tokenData = await this.getTokenData(tokenAddr);
            return {
                networkAndAddress: targetAddress,
                hasValidNft: true,
                tokens: [tokenData],
            };
        }
        else {
            return {
                networkAndAddress: targetAddress,
                hasValidNft: false,
            };
        }
    }
    async getValidNfts(targetAddress) {
        try {
            return this.getValidNftsCore(targetAddress);
        }
        catch (e) {
            let error;
            if (e instanceof KycDaoSDKError) {
                error = e;
            }
            else {
                error = new InternalError(String(e));
            }
            const errorMessage = error.toString();
            return {
                networkAndAddress: targetAddress,
                error: errorMessage,
            };
        }
    }
}
__decorate([
    Catch(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AptosJsonRpcProvider.prototype, "getValidNftsCore", null);
//# sourceMappingURL=aptos-json-rpc-provider.js.map